import React from "react";
import ticket1 from "../../../assets/images/rockinyangon/IMG_3861.png";
import ticket2 from "../../../assets/images/rockinyangon/IMG_3862.png";
const OurTicket = () => {
  return (
    <div className=" md:px-10 lg:px-20 px-5 ">
       <div className="w-20 h-[2px] bg-[#E83B37] mb-4"/>
      <div className="flex  justify-between items-center">
        
        <h1 className=" text-2xl md:text-3xl titlefont text-[#E83B37] font-medium">
          Our Tickets
        </h1>
        <button className="w-[200px] py-2 hover:bg-transparent border border-[#ed3E3D] hover:rounded-lg rounded-md transition-all text-white bg-[#ED3E3D]">
          Ticket ၀ယ်ယူရန်
        </button>
      </div>
      <div className="flex mt-14 justify-center gap-5">
      <div className="border border-red-600">
          <img src={ticket1} width={250} alt="" />
          <div className="flex flex-col gap-1 p-3 bg-[#131313]">
            <p className="titlefont text-base font-semibold md:text-lg  text-red-600">G A</p>
            <p className="textfont text-red-600 text-sm">25000 MMK</p>
            <button className="w-[120px] py-1 hover:bg-transparent border border-[#ed3E3D] hover:rounded-lg rounded-md transition-all text-white bg-[#ED3E3D]">
          Get Ticket
        </button>
          </div>
        </div>
        <div className="border border-red-600">
          <img src={ticket2} width={250} alt="" />
          <div className="flex flex-col gap-1 p-3 bg-[#131313]">
            <p className="titlefont text-base font-semibold md:text-lg  text-red-600">V I P</p>
            <p className="textfont text-red-600 text-sm">50000 MMK</p>
            <button className="w-[120px] py-1 hover:bg-transparent border border-[#ed3E3D] hover:rounded-lg rounded-md transition-all text-white bg-[#ED3E3D]">
          Get Ticket
        </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTicket;
